// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__2lrTW","container":"styles_container__3fDLw","formContainer":"styles_formContainer__18qyW","layoutWrapper":"styles_layoutWrapper__1ltFX"};